<template>
  <div class="md:hidden">
    <nav 
      class="fixed top-0 left-0 right-0 h-16 flex justify-between items-center px-6 z-[60] border-b border-white/5 shadow-xl"
      :style="{ background: 'radial-gradient(circle at top left, rgba(30, 41, 59, 1), rgba(15, 23, 42, 1))' }"
    >
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 flex items-center justify-center bg-white rounded-xl border border-white/10 shadow-inner">
          <img src="../assets/vague_bleue_petite.png" class="h-6 object-contain" alt="Logo" />
        </div>
        <img src="../assets/logo_medialink2017_final_blanc.png" class="h-5 object-contain" alt="MediaLink" />
      </div>

      <button 
        @click="isDrawerOpen = true" 
        class="w-10 h-10 flex items-center justify-center rounded-xl bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 hover:bg-indigo-500 hover:text-white transition-all duration-300"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </nav>

    <transition name="drawer-slide">
      <aside 
        v-if="isDrawerOpen" 
        class="fixed inset-0 z-[70] flex"
      >
        <div class="fixed inset-0 bg-slate-950/60 backdrop-blur-sm transition-opacity" @click="isDrawerOpen = false"></div>

        <div 
          class="relative w-80 h-full shadow-2xl flex flex-col border-r border-white/10"
          :style="{ background: 'radial-gradient(circle at top left, rgba(30, 41, 59, 1), rgba(15, 23, 42, 1))' }"
        >
          <div class="p-6 flex justify-between items-center border-b border-white/5">
            <div class="flex items-center gap-3">
              <div class="w-8 h-8 flex items-center justify-center bg-indigo-500/20 rounded-lg border border-white/10">
                <img src="../assets/vague_bleue_petite.png" class="h-5" alt="Logo" />
              </div>
              <span class="text-white font-bold tracking-tight">MediaLink</span>
            </div>
            <button @click="isDrawerOpen = false" class="text-gray-400 hover:text-white p-2">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <nav class="flex-1 px-4 py-6 space-y-8 overflow-y-auto scrollbar-none">
            <div class="space-y-2">
              <h3 class="px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-indigo-400/60 mb-4">
                Infrastructure
              </h3>
              <div class="space-y-1">
                <RouterLink
                  v-for="item in infrastructureMenu"
                  :key="item.label"
                  :to="item.to"
                  @click="isDrawerOpen = false"
                  class="flex items-center gap-4 rounded-xl px-4 py-3 text-sm transition-all duration-300 text-gray-400 border border-transparent hover:bg-white/5 hover:text-white;"
                  active-class="text-indigo-400"
                >
                  <div class="w-5 h-5 flex-shrink-0" v-html="item.icon"></div>
                  <span class="font-medium">{{ item.label }}</span>
                </RouterLink>
              </div>
            </div>

            <div class="space-y-2">
              <h3 class="px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-purple-400/60 mb-4">
                Administration
              </h3>
              <div class="space-y-1">
                <RouterLink
                  v-for="item in adminMenu"
                  :key="item.label"
                  :to="item.to"
                  @click="isDrawerOpen = false"
                  class="flex items-center gap-4 rounded-xl px-4 py-3 text-sm transition-all duration-300 text-gray-400 border border-transparent hover:bg-white/5 hover:text-white;"
                  active-class="text-indigo-400"
                >
                  <div class="w-5 h-5 flex-shrink-0" v-html="item.icon"></div>
                  <span class="font-medium">{{ item.label }}</span>
                </RouterLink>
              </div>
            </div>
          </nav>

          <div class="p-4 bg-white/5 backdrop-blur-md border-t border-white/5 space-y-4">
            <div class="flex items-center gap-3 px-2">
              <div class="relative">
                <img src="../assets/vague_bleue_petite.png" class="w-10 h-10 rounded-xl object-cover ring-2 ring-indigo-500/20" />
                <div class="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-500 rounded-full border-2 border-[#0f172a]"></div>
              </div>
              <div>
                <p class="text-sm font-semibold text-white">{{ user.prenom }} {{ user.nom }}</p>
                <p class="text-[10px] text-indigo-300 font-medium uppercase tracking-wider opacity-70">{{ user.role }}</p>
              </div>
            </div>

            <button
              @click="logout"
              class="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 text-gray-400 hover:text-rose-400 hover:bg-rose-500/10 border border-transparent hover:border-rose-500/20 font-semibold text-sm"
            >
              <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/>
              </svg>
              Déconnexion
            </button>
            
            <p class="text-[9px] text-center text-gray-500 font-medium uppercase tracking-[0.2em] opacity-50">
              © Datafuse Studio 2026
            </p>
          </div>
        </div>
      </aside>
    </transition>
    
    <div class="h-16"></div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

const ICONS = {
  dashboard: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/><rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/></svg>`,
  kiosk: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>`,
  screen: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="14" x="2" y="3" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>`,
  media: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.934a.5.5 0 0 0-.777-.416L16 11"/><rect width="14" height="12" x="2" y="6" rx="2"/></svg>`,
  client: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
  users: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2"/><path d="M4 14c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2"/></svg>`,
  tools: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>`,
  ticket: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9V5.2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2V9a2 2 0 0 0 0 4v3.8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V13a2 2 0 0 0 0-4Z"/><path d="M12 3v18"/><path d="m9 15 3-3 3 3"/><path d="m9 9 3 3 3-3"/></svg>`,
};

export default {
  components: { RouterLink },
  data() {
    return {
      isDrawerOpen: false,
      user: { prenom: 'MediaLink', nom: 'Solutions', role: 'Super Admin' },
      infrastructureMenu: [
        { label: "Dashboard", to: "/", icon: ICONS.dashboard },
        { label: "Kiosk", to: "/kiosk", icon: ICONS.kiosk },
        { label: "Ecran", to: "/screen", icon: ICONS.screen },
        { label: "Media", to: "/media-library", icon: ICONS.media },
      ],
      adminMenu: [
        { label: "Client", to: "/client", icon: ICONS.client },
        { label: "Counter & User", to: "/Counter-User", icon: ICONS.users },
        { label: "Support Technique", to: "/maintenance", icon: ICONS.tools },
        { label: "Ticket Client", to: "/ticket", icon: ICONS.ticket },
      ],
    };
  },
  methods: {
    logout() {
      console.log("Déconnexion...");
      this.isDrawerOpen = false;
    }
  }
};
</script>

<style scoped>
.scrollbar-none::-webkit-scrollbar { display: none; }
.scrollbar-none { -ms-overflow-style: none; scrollbar-width: none; }


/* État actif avec gradient identique à la Sidebar Desktop */
.active-gradient {
  background: linear-gradient(90deg, rgba(99, 102, 241, 0.2) 0%, rgba(168, 85, 247, 0.1) 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
}

.active-gradient svg {
  @apply text-indigo-400;
}

/* Transition du Drawer */
.drawer-slide-enter-active, .drawer-slide-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.drawer-slide-enter-from, .drawer-slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>